module.exports = __webpack_public_path__ + "img/red-flag.4f2d7cfb.svg";